import type { IMessage } from '@/modules/chat-matrix-fast/types/IChat'

interface PendingReplyEntry {
  replyToId: number | string
  replyToMessage: IMessage
  expiresAt: number
}

const pendingByTxnId = new Map<string, PendingReplyEntry>()
const TTL_MS = 60_000

export function registerPendingReplyMetadata(
  clientTxnId: string,
  replyToId: number | string,
  replyToMessage: IMessage,
): void {
  const key = clientTxnId.trim()
  if (!key) {
    return
  }

  pendingByTxnId.set(key, {
    replyToId,
    replyToMessage,
    expiresAt: Date.now() + TTL_MS,
  })
}

export function consumePendingReplyMetadata(txnId: string | null | undefined): {
  reply_to_id?: number | string
  reply_message_id?: number | string
  reply_to?: IMessage
} | null {
  const key = String(txnId || '').trim()
  if (!key) {
    return null
  }

  const entry = pendingByTxnId.get(key)
  if (!entry) {
    return null
  }

  pendingByTxnId.delete(key)

  if (Date.now() > entry.expiresAt) {
    return null
  }

  return {
    reply_to_id: entry.replyToId,
    reply_message_id: entry.replyToId,
    reply_to: entry.replyToMessage,
  }
}
